import React from 'react'
import PropTypes from 'prop-types'
import { confirmable } from 'react-confirm'

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
    width: '300px',
  },
  buttonContainer: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
  },
  button: {
    backgroundColor: '#8fbb42',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  buttonHover: {
    backgroundColor: '#bee777',
  },
}

const CustomDialog = ({ show, proceed, confirmation, options }) => (
  <div style={{ ...styles.overlay, display: show ? 'flex' : 'none' }}>
    <div style={styles.modal}>
      <p style={{ marginBottom: '10px' }}>{confirmation}</p>
      <div style={styles.buttonContainer}>
        <button
          style={styles.button}
          onMouseEnter={(e) =>
            (e.target.style.backgroundColor =
              styles.buttonHover.backgroundColor)
          }
          onMouseLeave={(e) =>
            (e.target.style.backgroundColor = styles.button.backgroundColor)
          }
          onClick={() => proceed(true)}
        >
          Yes
        </button>
        <button
          style={{ ...styles.button, backgroundColor: '#1c313f' }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#2c2c2c')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#1c313f')}
          onClick={() => proceed(false)}
        >
          No
        </button>
      </div>
    </div>
  </div>
)

CustomDialog.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  confirmation: PropTypes.string,
  options: PropTypes.object,
}

export default confirmable(CustomDialog)
